import { Component, Input, OnInit, EventEmitter, Output, OnChanges } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CreateKaizen } from '../models/Kaizen';

@Component({
    selector: 'app-description',
    templateUrl: './description.component.html',
    styleUrls: ['./description.component.css'],
    standalone: false
})
export class DescriptionComponent implements OnInit, OnChanges 
{
  CreateKaizenDescription : CreateKaizen = new CreateKaizen();
  @Input() CreateKaizen: CreateKaizen = new CreateKaizen();
  @Output() emitKaizenDescription: EventEmitter<{CreateKaizen:CreateKaizen, isValid: boolean}> = new EventEmitter<{CreateKaizen:CreateKaizen, isValid: boolean}>();
  formDescription!: UntypedFormGroup;
  isValid: boolean = true;
  includeCostInObeyaYesNo: string = 'No';
  isObeyaChecked: boolean = false;
 
  constructor(private formBuilder: UntypedFormBuilder) { 
    this.formDescription = this.formBuilder.group({
      kaizenTitle: ['', [Validators.required, Validators.maxLength(200)]],
      kaizenDescription: ['', [Validators.required, Validators.maxLength(2000)]],
      includeCostInObeya:[false],
      isBOD:[true],
      internalTrackingNo:[''],
      trackingRef1:[''],
      trackingRef2:[''],
      kaizenAdditionalComments:  ['', Validators.maxLength(2000)]
    });
  }

  ngOnInit(): void {}

  ngOnChanges() 
  {
    this.CreateKaizenDescription.title = this.CreateKaizen.title??'';
    this.CreateKaizenDescription.description = this.CreateKaizen.description??'';
    this.CreateKaizenDescription.includeCostInObeya = this.CreateKaizen.includeCostInObeya??'';
    this.CreateKaizenDescription.isBOD = this.CreateKaizen.isBOD == null || undefined ? true : this.CreateKaizen.isBOD;
    this.CreateKaizenDescription.internalTrackingNo = this.CreateKaizen.internalTrackingNo  == undefined ? '' : this.CreateKaizen.internalTrackingNo;
    this.CreateKaizenDescription.trackingRef1 = this.CreateKaizen.trackingRef1 == undefined ? '' : this.CreateKaizen.trackingRef1;
    this.CreateKaizenDescription.trackingRef2 = this.CreateKaizen.trackingRef2  == undefined ? '' : this.CreateKaizen.trackingRef2;
    this.CreateKaizenDescription.additionalComments = this.CreateKaizen.additionalComments??'';
    this.formDescription.controls['kaizenTitle'].setValue(this.CreateKaizenDescription.title);
    this.formDescription.controls['internalTrackingNo'].setValue(this.CreateKaizenDescription.internalTrackingNo);
    this.formDescription.controls['trackingRef1'].setValue(this.CreateKaizenDescription.trackingRef1);
    this.formDescription.controls['trackingRef2'].setValue(this.CreateKaizenDescription.trackingRef2);
    this.formDescription.controls['kaizenDescription'].setValue(this.CreateKaizenDescription.description);
    this.formDescription.controls['includeCostInObeya'].setValue(this.CreateKaizenDescription.includeCostInObeya);
    this.formDescription.controls['isBOD'].setValue(this.CreateKaizenDescription.isBOD == false ? true : false);
    this.formDescription.controls['kaizenAdditionalComments'].setValue(this.CreateKaizenDescription.additionalComments);
    this.includeCostInObeyaYesNo = this.CreateKaizen.includeCostInObeya ? 'Yes' : 'No';
  }

  emitDescription() {
      this.emitKaizenDescription.emit({CreateKaizen: this.CreateKaizenDescription, isValid: this.isValid});    
  }

  descriptionKeyUp(e: any) 
  {
    this.CreateKaizenDescription.description = e.target.value;
    if ( (this.CreateKaizenDescription.title.length > 0 && this.CreateKaizenDescription.title.length <= 200)  
         && (this.CreateKaizenDescription.description.length > 0 && this.CreateKaizenDescription.title.length <= 2000) 
        //  && this.CreateKaizenDescription.additionalComments.length <= 2000
       )
    { 
      this.isValid = true;      
    }    
    else 
    {
      this.isValid = false;
    }
    this.emitDescription();
  }

  titleKeyUp(e: any) 
  {
    this.CreateKaizenDescription.title = e.target.value;
    if ( (this.CreateKaizenDescription.title.length > 0 && this.CreateKaizenDescription.title.length <= 200)  
         && (this.CreateKaizenDescription.description.length > 0 && this.CreateKaizenDescription.title.length <= 2000)  
        //  && this.CreateKaizenDescription.additionalComments.length <= 2000
       )
      { 
        this.isValid = true;      
      }    
      else 
      {
        this.isValid = false;
      }
      this.emitDescription();  
  }
  internalTrackingNoKeyUp(e:any){
    this.CreateKaizenDescription.internalTrackingNo = e.target.value;
    this.emitDescription();  
  }
  trackingRef1KeyUp(e:any){
    this.CreateKaizenDescription.trackingRef1 = e.target.value;
    this.emitDescription();  
  }
  trackingRef2KeyUp(e:any){
    this.CreateKaizenDescription.trackingRef2 = e.target.value;
    this.emitDescription();  
  }

  includeCostInObeyaChecked(e: any) 
  {
    this.isObeyaChecked = e.target.checked;
    this.CreateKaizenDescription.includeCostInObeya = this.isObeyaChecked;
    this.includeCostInObeyaYesNo = this.isObeyaChecked ? 'Yes' : 'No';
    if (!this.isObeyaChecked) {
      this.CreateKaizenDescription.isBOD = true;
    }
    this.emitDescription();
  }
  isBODChecked(e:any)
  {
    this.CreateKaizenDescription.isBOD = e.target.checked == true ? false : true;
    this.emitDescription();
  }
  additionalCommentsKeyUp(e: any) 
  {
    this.CreateKaizenDescription.additionalComments = e.target.value;
    if ( (this.CreateKaizenDescription.title.length > 0 && this.CreateKaizenDescription.title.length <= 200)  
         && (this.CreateKaizenDescription.description.length > 0 && this.CreateKaizenDescription.title.length <= 2000)  
        //  && this.CreateKaizenDescription.additionalComments.length <= 2000
       )
      { 
        this.isValid = true;      
      }    
      else 
      {
        this.isValid = false;
      }
      this.emitDescription();   
  }


}
